/**
 * What a 拼字 Exercise says to a reader, in the words the reading and grammar
 * exercises use (`./lianxi-yuedu-copy.ts`): Correct 对 and Incorrect 不对.
 * The square under the line shows the character put together, so the line
 * never spells the parts out.
 */
export const pinziCopy = {
  /** The line over the characters saying where the reader is. */
  progress: (at: number, of: number): string =>
    `Character ${String(at)} of ${String(of)}`,

  right: "Correct 对",
  wrong: "Incorrect 不对. You'll try this character again.",

  /** The finish, with how many were built right first time. */
  finished: (right: number, of: number): string =>
    `Exercise complete. You built ${String(right)} of ${String(of)} characters correctly the first time.`,

  /** What the finish adds once the characters are in 复习, where the cards were not counted. */
  handedOver: "Characters from the exercise are in Review.",
} as const;
